<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">

  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <fa-icon class="fas checklistIcon" title="click for smart checklist" (click)="openSmartChecklist()"  [icon]="faCircle">
          </fa-icon>
          <fa-icon class="fas fa-lg autoCursor" [icon]="faCubes"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize">{{ 'menu.scopeMapper' | translate }}</h6>
      </div>
      <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-6">
        <p class="titleParagraph">{{'scopeMapper.toolHeaderLine1' | translate}}<br>
          {{'scopeMapper.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
      </div>
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
        <table class="dropGroupBtn">
          <tr>
            <td class="iconGroupHeight">
              <span>
                <a id="scopeYoutube" type="button" class="" data-toggle="modal" data-target="#ytVideoLinkSM">
                  <fa-icon class="fas" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <fa-icon class="fas fa-lg" [icon]="faProjectDiagram"
                (click)="mainComponent.openTool('scopeMapperMindMap');mainComponent.createActivity('Scm');" routerLink="/main/scopeMapperMindMap"></fa-icon>
                <!-- project.views.open('Scm');interactionMapperComponent.init();scopeMapperMindmap.controller.scopeGraphShowHide(false); -->
                <!-- interactionMapperComponent.setMappingSelectedyEutScope('Feature', scopeMapperMindmap.controller.scopeGraphStatus); -->
              </span>
            </td>
          </tr>
          <tr class="bg-color-black">
            <td class="height25px">
              <span (click)="generateReport('true')">
                <fa-icon class="fas margintop7pxminus" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <!-- Section header end -->
  <div class="scopetool tool-body-height">
    <div class="card p-1 mb-2 bg-white h-100">
      <div class="persona-mapper-grid-table-height">
        <div class="row full-width only-bottom-padding h-50 card p-1 bg-white">

          <div class="table-responsive">
            <table class="table table-bordered border-none table-sm s-mapper tableBackgrdClrBlack menuItemsClrWhite">
              <tbody>
                <tr class="table-bordered-bottom"
                  *ngFor="let p of model.scopeMapUI[model.eutType] ; let tabIndex = index">
                  <th class="border-right1px border-left1px">
                    {{p.name.level}}
                  </th>
                  <th class="border-right1px">
                    <div class="pr-2" data-toggle="tooltip" title="{{p.name.name}}: {{getAttributeDesc(p)}}"
                      data-placement="right">
                      <!-- uib-tooltip="{{p.name.name}}: {{getAttributeDesc(p)}}" tooltip-placement="right" -->
                      {{p.name.symbol}} &nbsp;
                      <fa-icon *ngIf="!checkAttributeDesc(p,'icon')" class="fas menuItemsClrWhite floatright "
                        [icon]="faCheck"></fa-icon>
                      <fa-icon *ngIf="!checkAttributeMapped(p,'icon')" class="fas menuItemsClrWhite floatright pr-2"
                        [icon]="faExclamation"></fa-icon>
                      &nbsp;&nbsp;
                    </div>
                  </th>
                  <td class="border-right1px mapperReadOnly" *ngFor="let eut of p.eutList; let tabIndex = index"
                    [ngClass]="{paleyellow:eut.map=='*'}" (click)="eut.map!=-1 && update(p,tabIndex,eut.eID)">
                    <div style="text-align: center;">
                      <b *ngIf="eut.map!=-1"></b>&nbsp;
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-nonresponsive s-mapper-table">
            <table width="100%" border="0" cellspacing="0" cellpadding="0"
              class="table table-bordered border-none table-xs s-mapper tableBackgrdClrBlack">
              <tbody>
                <tr class="table-bordered-bottom"
                  [ngClass]="{displayNone:model.scopeMapIndex[model.eutType].length!=tabIndex+1}"
                  *ngFor="let p of model.scopeMapIndex[model.eutType]; let tabIndex = index">
                  <th class="border-left1px">
                    &nbsp;
                  </th>
                  <th class="border-right1px">&nbsp;</th>
                  <td class="tableXCount border-right1px" *ngFor="let eut of p.eutList; let tabIndex = index"
                    [ngClass]="{dis:eut.map==-1||eut.map!=''}" (click)="update(p,tabIndex,eut.eID)">
                    <span *ngIf="eut.map!=-1">{{eut.map}}</span>&nbsp;
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>

        <div class="card h-50 p-1 bg-white">
          <!-- row full-width -->
          <div class="row strict">
            <ul class="nav nav-tabs" role="tablist">
              <li class="active" id="yAxisFeatureTableSM">
                <a data-toggle="tab" ng-attr-data-target="#fe123"
                  (click)="setEUTtypeChosen('TF');activeTab('yAxisFeatureTableSM')">
                  {{ 'entities.Fe' | translate }}&nbsp;
                  ({{(modelData.listOfEUTs|landscaperEntity:{eType:'TF'}:filterTypeCount)}})
                </a>
              </li>
              <li id="yAxisRequirementTableSM">
                <a data-toggle="tab" ng-attr-data-target="#ur123"
                  (click)="setEUTtypeChosen('UR');activeTab('yAxisRequirementTableSM')">
                  {{ 'entities.Ur' | translate }}&nbsp;
                  ({{(modelData.listOfEUTs|landscaperEntity:{eType:'UR'}:filterTypeCount)}})
                </a>
              </li>
              <li id="yAxisFlowTableSM">
                <a data-toggle="tab" ng-attr-data-target="#bf123"
                  (click)="setEUTtypeChosen('BF');activeTab('yAxisFlowTableSM')">
                  {{ 'entities.Bf' | translate }}&nbsp;
                  ({{(modelData.listOfEUTs|landscaperEntity:{eType:'BF'}:filterTypeCount)}})
                </a>
              </li>
              <li id="yAxisUnspecTableSM">
                <a data-toggle="tab" ng-attr-data-target="#xx123"
                  (click)="setEUTtypeChosen('XX');activeTab('yAxisUnspecTableSM')">
                  {{ 'entities.Xx' | translate }}&nbsp;
                  ({{(modelData.listOfEUTs|landscaperEntity:{eType:'XX'}:filterTypeCount)}})
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-content scope-graph-nav-tab-content-height">
            <div ng-attr-id="fe123" class="tab-pane fade in active h-100" *ngIf="activeTabID =='yAxisFeatureTableSM'">
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.eutType)" class="list-group">
                <div class="alert alert-warning mb-0">
                  <strong>
                    <div style="text-align: center;">
                      {{ 'emptyEntitiesErrors.Fe' | translate }}
                    </div>
                  </strong>
                </div>
              </ul>
              <table class="table env1 mb-0 h-100 tableBackgrdClrBlack menuItemsClrWhite"
                *ngIf="entityExists(model.eutType)">
                <thead class="" *ngIf="entityExists(model.eutType)">
                  <tr class=" row strict">
                    <th class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isAllSelected()"
                          (click)="toggleAllDeselect($event.target.checked)">
                      </div>
                    </th>
                    <th class="col-xs-1"></th>
                    <th class="col-xs-9">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody class="toolEntityTBody">
                  <tr class=" row strict" *ngFor="let eut of pagedItems; let tabIndex = index">
                    <!-- ng-repeat="eut in scopeMapper.model.eutCollection[scopeMapper.model.eutType] |limitTo : scopeMapper.model.listLength:scopeMapper.model.startAt" -->
                    <td class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isChecked(eut.eID)"
                          (click)="toggleSelection(eut.eID)">
                      </div>
                    </td>
                    <td class="col-xs-1">
                      {{model.eutCollection [model.eutType].indexOf(eut)+1}}</td>
                    <td class="col-xs-9">{{getModuleName(eut)}} | {{eut.eName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div ng-attr-id="ur123" class="tab-pane active fade in h-100"
              *ngIf="activeTabID =='yAxisRequirementTableSM'">
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.eutType)" class="list-group">
                <div class="alert alert-warning mb-0">
                  <strong>
                    <div style="text-align: center;">
                      {{ 'emptyEntitiesErrors.Ur' | translate }}
                    </div>
                  </strong>
                </div>
              </ul>
              <table class="table env1 mb-0 h-100 tableBackgrdClrBlack menuItemsClrWhite"
                *ngIf="entityExists(model.eutType)">
                <thead *ngIf="entityExists(model.eutType)">
                  <tr class=" row strict">
                    <th class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isAllSelected()"
                          (click)="toggleAllDeselect($event.target.checked)">
                      </div>
                    </th>
                    <th class="col-xs-1"></th>
                    <th class="col-xs-9">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody class="toolEntityTBody">
                  <tr class=" row strict" *ngFor="let eut of pagedItems; let tabIndex = index">
                    <!-- ng-repeat="eut in scopeMapper.model.eutCollection[scopeMapper.model.eutType] |limitTo : scopeMapper.model.listLength:scopeMapper.model.startAt" -->
                    <td class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isChecked(eut.eID)"
                          (click)="toggleSelection(eut.eID)">
                      </div>
                    </td>
                    <td class="col-xs-1">
                      {{model.eutCollection [model.eutType].indexOf(eut)+1}}</td>
                    <td class="col-xs-9"> {{getModuleName(eut)}} | {{eut.eName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div ng-attr-id="bf123" class="tab-pane active fade in h-100" *ngIf="activeTabID =='yAxisFlowTableSM'">
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.eutType)" class="list-group">
                <div class="alert alert-warning mb-0">
                  <strong>
                    <div style="text-align: center;">
                      {{ 'emptyEntitiesErrors.Bf' | translate }}
                    </div>
                  </strong>
                </div>
              </ul>
              <table class="table env1 mb-0 h-100 tableBackgrdClrBlack menuItemsClrWhite"
                *ngIf="entityExists(model.eutType)">
                <thead *ngIf="entityExists(model.eutType)">
                  <tr class=" row strict">
                    <th class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isAllSelected()"
                          (click)="toggleAllDeselect($event.target.checked)">
                      </div>
                    </th>
                    <th class="col-xs-1"></th>
                    <th class="col-xs-9">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody class="toolEntityTBody">
                  <tr class=" row strict" *ngFor="let eut of pagedItems; let tabIndex = index">
                    <!-- ng-repeat="eut in scopeMapper.model.eutCollection[scopeMapper.model.eutType] |limitTo : scopeMapper.model.listLength:scopeMapper.model.startAt" -->
                    <td class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isChecked(eut.eID)"
                          (click)="toggleSelection(eut.eID)">
                      </div>
                    </td>
                    <td class="col-xs-1">
                      {{model.eutCollection [model.eutType].indexOf(eut)+1}}</td>
                    <td class="col-xs-9"> {{getModuleName(eut)}} | {{eut.eName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div ng-attr-id="xx123" class="tab-pane active fade in h-100" *ngIf="activeTabID =='yAxisUnspecTableSM'">
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.eutType)" class="list-group">
                <div class="alert alert-warning mb-0">
                  <strong>
                    <div style="text-align: center;">
                      {{ 'emptyEntitiesErrors.Xx' | translate }}
                    </div>
                  </strong>
                </div>
              </ul>
              <ul class="alert-height list-group h-100 mb-0" *ngIf="!entityExists(model.eutType)" class="list-group">
                <div class="alert alert-warning mb-0">
                  <strong>
                    <div style="text-align: center;">
                      {{ 'emptyEntitiesErrors.Xx' | translate }}
                    </div>
                  </strong>
                </div>
              </ul>
              <table class="table env1 mb-0 h-100 tableBackgrdClrBlack menuItemsClrWhite"
                *ngIf="entityExists(model.eutType)">
                <thead *ngIf="entityExists(model.eutType)">
                  <tr class=" row strict">
                    <th class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isAllSelected()"
                          (click)="toggleAllDeselect($event.target.checked)">
                      </div>
                    </th>
                    <th class="col-xs-1"></th>
                    <th class="col-xs-9">{{ 'entities.nameOfEntity' | translate }}</th>
                  </tr>
                </thead>
                <tbody class="toolEntityTBody">
                  <tr class=" row strict" *ngFor="let eut of pagedItems; let tabIndex = index">
                    <!-- ng-repeat="eut in scopeMapper.model.eutCollection[scopeMapper.model.eutType] |limitTo : scopeMapper.model.listLength:scopeMapper.model.startAt" -->
                    <td class="col-xs-1 ">
                      <div style="text-align: center;">
                        <input class="checkboxReadOnly" type="checkbox" [checked]="isChecked(eut.eID)"
                          (click)="toggleSelection(eut.eID)">
                      </div>
                    </td>
                    <td class="col-xs-1">
                      {{model.eutCollection [model.eutType].indexOf(eut)+1}}</td>
                    <td class="col-xs-9"> {{getModuleName(eut)}} | {{eut.eName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row entity-row">
        <div style="text-align: center;">
          <div class="btn-group" role="group">
            <button id="faStepBackwardSM" class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }" (click)="firstPage();setPage(1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepBackward"></fa-icon>
            </button>
            <button id="faAngleLeftSM" class="btn btn-sm btn-default" [ngClass]="{ dis: !disableUp }"
              (click)="previousPage();setPage(pager.currentPage - 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleLeft"></fa-icon>
            </button>
            <button id="faAngleRightSM" class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }"
              (click)="nextPage();setPage(pager.currentPage + 1)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faAngleRight"></fa-icon>
            </button>
            <button id="faStepForwardSM" class="btn btn-sm btn-default" [ngClass]="{ dis: !disableDown }"
              (click)="lastPage();setPage(pager.totalPages)">
              <fa-icon class="fa menuItemsClrBlack" [icon]="faStepForward"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="scopemapperTip" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #1 : {{'scopeMapper.tip1' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #2 : {{'scopeMapper.tip2' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #3 : {{'scopeMapper.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#scopemapperTip"
          data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#scopemapperTip"
          data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
  <!-- Youtube video Modal start-->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkSM" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkSM" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">{{'youtubeVideoTitle.scopemapper' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="ScVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Youtube video Modal end-->
</div>